import { render } from "./PartnerHome.vue?vue&type=template&id=7873822d&scoped=true"
const script = {}

import "./PartnerHome.vue?vue&type=style&index=0&id=7873822d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7873822d"

export default script